export default {
  title: "Vítejte ve svém novém Ulsemo online obchodu",
  message: `Jsme velmi rádi, že jste se rozhodli začít Vaše online podnikání na Ulsemu! Připravili jsme pro vás rychlého průvodce, který Vám
  umožní rychlé a snadné nastavení všeho potřebného.
  <br/><br/> <b>Chcete vytvořit celý online obchod nebo jen prodat něco přes tržiště Ulsemo? </b>`,
  marketplace_button: "Pouze přes tržiště",
  full_button: "Chci celý obchod"
}
